import {Component} from "@angular/core";

@Component({
    selector: "fui-ftb-section",
    styleUrls: ["./ftb-section.component.scss"],
    templateUrl: "./ftb-section.component.html",
    standalone: false
})
export class FUIFTBSectionComponent {
}
